import SearchIcon from '@mui/icons-material/Search';
import { TextField, Theme } from '@mui/material';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import classNames from "classnames";
import BoxDrawer from 'components/BoxDrawer';
import IconButtonCancel from 'components/Buttons/IconButtonCancel';
import { SpinnerIndicator } from 'components/CallServer';
import { GridEx } from 'components/MuiExtras/Grid/GridEx';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiLink from 'components/MuiExtras/MuiLink';
import MuiPagination from 'components/MuiExtras/MuiPagination';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import UsernameInspect from 'components/UsernameInspect';
import { DashboardUserModel, PagedResult } from 'models/ApiModels';
import * as React from 'react';
import Session from 'services/Session';
import { getUserProfileUrl } from 'views/Timeline/Components/FeedHelpers';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const styles = (theme: Theme) => createStyles({
    table: {
        margin: 0,
        padding: 0,
        width: "100%"
    },
    tableCell: {
        verticalAlign: "middle",
        paddingBottom: theme.spacing,
    },
    tableCell1px: {
        width: "1px"
    }
});

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    ds: PagedResult<DashboardUserModel>;
    offset: number;
    loading: boolean;
    lastError: any;
    searchText: string;
}

interface IProps {
    title: string;
    subtitle: string;
    answersFromUserId?: string;
    showTotalColumn?: boolean;
    onClose: () => void;
    onGetData: (searchText: string, offset: number, take: number) => Promise<PagedResult<DashboardUserModel>>
}

type Props = IProps & WithStyles<typeof styles>;

const rowsPerPage = 15;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class UserListDrawer extends React.PureComponent<Props, IState> {

    private searchRef: any = null;

    constructor(props: Props) {
        super(props);
        this.state = {
            ds: null,
            offset: 0,
            loading: true,
            lastError: null,
            searchText: ""
        }
    }

    private getData(offset: number) {
        this.setState({ loading: true });

        this.props.onGetData(this.state.searchText, offset, rowsPerPage)
            .then((result: PagedResult<DashboardUserModel>) => {
                this.setState({ ds: result, loading: false, lastError: null, offset: offset });
            })
            .catch((error) => {
                this.setState({ ds: null, lastError: error, loading: false, offset: 0 });
            });
    }

    private handleSearch(e: React.KeyboardEvent<HTMLDivElement>) {
        if (e.keyCode == 13) this.getData(0);
    }

    private renderContent() {
        const { ds, loading } = this.state;
        const { classes } = this.props;

        return (
            <GridEx container fullHeight direction="column" wrap="nowrap">
                <GridEx>

                    <MuiContainer>
                        <TextField
                            fullWidth
                            placeholder="Pesquisar…"
                            value={this.state.searchText}
                            onChange={() => this.setState({ searchText: this.searchRef.value })}
                            onKeyDown={(e) => this.handleSearch(e)}
                            onBlur={() => this.getData(0)}
                            inputRef={(ref) => this.searchRef = ref}
                            InputProps={
                                {
                                    startAdornment: <SearchIcon />,
                                    endAdornment: this.state.searchText != ""
                                        ? <IconButtonCancel
                                            size="small"
                                            onClick={
                                                () => {
                                                    this.setState({ searchText: "" }, () => this.getData(0));
                                                }
                                            } />
                                        : null
                                }
                            }
                        />
                    </MuiContainer>

                </GridEx>
                <GridEx item xs overflow="auto">
                    {
                        loading
                            ? <SpinnerIndicator />
                            : (
                                <table className={classes.table}>
                                    {
                                        this.props.showTotalColumn &&
                                        <thead>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td align="right"><b>Total</b></td>
                                        </thead>
                                    }
                                    <tbody>
                                        {
                                            ds.items.map((v, index) => {

                                                var url = getUserProfileUrl(v.userId);

                                                return (
                                                    <tr key={index}>
                                                        <td className={classNames(classes.tableCell, classes.tableCell1px)}>
                                                            <img src={v.thumbnailUrl} alt={v.name} width="32" height="32" />
                                                        </td>
                                                        <td className={classes.tableCell}>
                                                            <MuiLink color="secondary" href={url} target="_blank" >
                                                                <UsernameInspect user={v} />
                                                            </MuiLink>
                                                        </td>
                                                        {
                                                            this.props.showTotalColumn === true && v.total &&
                                                            <td align="right" className={classNames(classes.tableCell, classes.tableCell1px)}>
                                                                {
                                                                    v.userId == Session.user.id
                                                                        ? <b>{v.total.toLocaleString()}</b>
                                                                        : <span>{v.total.toLocaleString()}</span>
                                                                }
                                                            </td>
                                                        }
                                                    </tr>
                                                );
                                            })
                                        }
                                    </tbody>
                                </table>
                            )
                    }
                </GridEx>

                {
                    !loading &&
                    <GridEx item>
                        <MuiPagination
                            limit={rowsPerPage}
                            offset={this.state.offset}
                            total={ds.total}
                            onClick={(e, offset) => this.getData(offset)}
                        />
                    </GridEx>
                }
            </GridEx>
        );
    }

    public componentDidMount() {
        this.getData(0);
    }

    public render() {
        const { title, subtitle, onClose } = this.props;

        return (
            <BoxDrawer
                open
                overflow="hidden"
                onClose={() => onClose()}
                title={title}
                subtitle={subtitle}
            >
                <MuiPaper fullHeight elevation={0}>
                    {this.renderContent()}
                </MuiPaper>
            </BoxDrawer>
        );
    }
}

export default withStyles(styles)(UserListDrawer)